import WoundDistributionMultiple from '@/assets/icons/wound_distribution_multiple.svg?component';
import WoundDistributionNo from '@/assets/icons/wound_distribution_no.svg?component';
import WoundDistributionOne from '@/assets/icons/wound_distribution_one.svg?component';
import type { IconComponent } from '@/components/atoms/SvgIcon/SvgIcon';
import TitleIcon, { type TitleIconTone } from '@/components/atoms/TitleIcon/TitleIcon';

const DISTRIBUTION_ICON_SIZE_PX = 32;

export type WoundDistributionLegendIconVariant = 'noWound' | 'oneWound' | 'multipleWounds';

const ICON_CONFIG: Record<
    WoundDistributionLegendIconVariant,
    { tone: TitleIconTone; icon: IconComponent }
> = {
    noWound: { tone: 'success', icon: WoundDistributionNo },
    oneWound: { tone: 'caution', icon: WoundDistributionOne },
    multipleWounds: { tone: 'warning', icon: WoundDistributionMultiple },
};

export interface HealthWoundDistributionLegendIconProps {
    variant: WoundDistributionLegendIconVariant;
}

export default function HealthWoundDistributionLegendIcon(
    props: HealthWoundDistributionLegendIconProps
) {
    const { tone, icon } = ICON_CONFIG[props.variant];

    return <TitleIcon icon={icon} tone={tone} iconSize={DISTRIBUTION_ICON_SIZE_PX} />;
}
